import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useFetch from "utils/hooks/useFetch";
import { GET_ALL_TICKETS } from "api";
import formatCurrency from "../helpers/formatCurrency";
import ArrowRight from "pages/assets/icons/arrow-right";

function TicketList({ golfNGrow }) {
  const navigate = useNavigate();
  const { data: tickets, fetch: getAllTickets } = useFetch(GET_ALL_TICKETS);
  const { t } = useTranslation();

  useEffect(() => {
    getAllTickets({ query: { is_golf_n_grow: golfNGrow ? true : false } });
  }, []);

  return (
    <div>
      {(tickets &&
        tickets.length > 0 &&
        tickets.map((ticket) => {
          return (
            <div
              key={ticket && ticket.id}
              className="flex gap-4 px-5 py-3 mb-3 border-2 shadow-md cursor-pointer md:gap-6 md:px-10 md:py-5 md:mb-5 rounded-xl border-slate-100"
              onClick={() =>
                navigate(`/price-details/${ticket && ticket.id}`, {
                  state: { golfNGrow },
                })
              }
            >
              <div className="h-20 overflow-hidden bg-black w-28 md:w-60 md:h-48 rounded-xl">
                <img
                  src={ticket && ticket.thumbnail_url}
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="w-full space-y-2">
                <div>
                  <div className="text-xs text-app-blue-3 sm:text-sm">
                    {/* {ticket && moment(ticket.date).format('DD MMMM YYYY')} */}
                    {ticket && ticket?.is_group_ticket
                      ? t("scramblePax")
                      : t("singlePax")}
                  </div>
                </div>
                <div>
                  <div className="font-bold text-md sm:text-2xl">
                    {ticket && ticket.title}
                  </div>
                </div>
                {ticket && ticket?.is_group_ticket && (
                  <div>
                    <div className="text-sm sm:text-lg">
                      {t("scrambleBundling")}
                    </div>
                  </div>
                )}
                {/* <div>
                  <div className="text-sm sm:text-lg">
                    {formatCurrency(ticket && ticket.price)} /{" "}
                    {ticket && ticket.is_group_ticket ? t("group") : t("pax")}
                  </div>
                </div> */}
                {ticket && ticket?.is_group_ticket && (
                  <div className="w-full p-2 text-xs leading-5 border border-2 rounded-lg sm:text-sm bg-app-blue-light border-app-blue-4/40">
                    {t("scrambleNote")}
                  </div>
                )}
                <div className="flex justify-end">
                  <div
                    className={`flex items-center gap-1 mt-5 text-sm font-bold select-none sm:text-base md:mt-${ticket && ticket?.is_group_ticket ? "20" : "28"}`}
                  >
                    {t("viewDetails")}
                    <ArrowRight fill={"#156040"} width={15} />
                  </div>
                </div>
              </div>
            </div>
          );
        })) || <div></div>}
    </div>
  );
}

export default TicketList;
